import * as api from '@/http'

export const ActionSetExternalEmployee = async ({ commit }) => {
  const external_employee = await api.http.get('dash/external_employee').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_externalEmployee', external_employee)
}
